import React from 'react';

const Tags = props => {
  const { tags } = props;
  return (
    <div>
      {tags && tags.length > 0
        ? tags.map(tag => (
          // styles from https://www.levels.fyi/still-hiring/
          <span className="Todo__tag">
            #
            {tag}
            {' '}
          </span>
        ))
        : ''}
    </div>
  );
};

export default Tags;
